import moment from "moment";
import { getPlannedBudgetDateLabel } from "../../../../../utils/helpers/getPlannedBudgetDateLabel";
import { BudgetPeriod } from "@/services/cloudchipr.api";

export const isCurrentPlannedBudgetPeriod = (
  budgetLabel: string,
  period: BudgetPeriod,
  quarterStartMonth?: number,
  customDate?: string,
): boolean => {
  const currentDate = moment(customDate).format("YYYY-MM-DD");
  const currentDateLabel = getPlannedBudgetDateLabel(
    period,
    currentDate,
    0,
    quarterStartMonth,
  );

  // Ignore the year for the comparison to identify recurring budgets as well
  const currentDateMonthOrQuarter = currentDateLabel.split(" ").at(0);
  const budgetMonthOrQuarter = budgetLabel.split(" ").at(0);

  return currentDateMonthOrQuarter === budgetMonthOrQuarter;
};
